export type EmailBodySegment =
  | { readonly kind: "text"; readonly value: string }
  | { readonly kind: "strong"; readonly value: string }
  | { readonly kind: "highlight"; readonly value: string };

export class EmailBodyMarkupMapper {
  static readonly HIGHLIGHT_COLOR = "#cc0000";
  static readonly SPAN_OPEN = `<span style="color:${EmailBodyMarkupMapper.HIGHLIGHT_COLOR}">`;
  static readonly FONT_OPEN = `<font color="${EmailBodyMarkupMapper.HIGHLIGHT_COLOR}">`;
  static readonly HIGHLIGHT_OPEN = `${EmailBodyMarkupMapper.SPAN_OPEN}${EmailBodyMarkupMapper.FONT_OPEN}`;
  static readonly HIGHLIGHT_CLOSE = "</font></span>";

  static readonly MARKUP_TAGS = [
    "<strong>",
    "</strong>",
    EmailBodyMarkupMapper.SPAN_OPEN,
    EmailBodyMarkupMapper.FONT_OPEN,
    "</font>",
    "</span>",
  ] as const;

  private static readonly MARKUP = new RegExp(
    `<strong>([\\s\\S]*?)</strong>|${EmailBodyMarkupMapper.HIGHLIGHT_OPEN}([\\s\\S]*?)${EmailBodyMarkupMapper.HIGHLIGHT_CLOSE}`,
    "gi",
  );

  highlight(text: string): string {
    return `${EmailBodyMarkupMapper.HIGHLIGHT_OPEN}${text}${EmailBodyMarkupMapper.HIGHLIGHT_CLOSE}`;
  }

  map(html: string): EmailBodySegment[] {
    const segments: EmailBodySegment[] = [];
    const pattern = EmailBodyMarkupMapper.MARKUP;
    pattern.lastIndex = 0;
    let cursor = 0;
    let match = pattern.exec(html);
    while (match) {
      if (match.index > cursor) {
        segments.push({
          kind: "text",
          value: this.decodeEntities(html.slice(cursor, match.index)),
        });
      }
      if (match[1] !== undefined) {
        segments.push({ kind: "strong", value: this.decodeEntities(match[1]) });
      } else {
        segments.push({ kind: "highlight", value: this.decodeEntities(match[2]) });
      }
      cursor = match.index + match[0].length;
      match = pattern.exec(html);
    }
    if (cursor < html.length) {
      segments.push({
        kind: "text",
        value: this.decodeEntities(html.slice(cursor)),
      });
    }
    return segments;
  }

  private decodeEntities(raw: string): string {
    return raw.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&");
  }
}
